import { useCallback, useEffect, useState } from 'react';
import { analyticsService } from '../services/analyticsService';
import { normalizeCatalog } from '../adapters/normalizeCatalog';

export default function useAnalyticsCatalog() {
  const [catalog, setCatalog] = useState({ datasets: [], questionTypes: [] });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    const res = await analyticsService.getCatalog();
    if (!res.ok) {
      setError('Failed to load catalog');
      setIsLoading(false);
      return;
    }
    setCatalog(normalizeCatalog(res.data));
    setIsLoading(false);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { catalog, isLoading, error, reload: load };
}
